import React from "react";
import "./stageFlow.css";

const StageFlow = ({ currentStage }) => {
    if (!currentStage || currentStage == "0") {
    return null; // ไม่ render อะไรเลย
  }
  const isCloseStage =
    currentStage === "Close-Won" || currentStage === "Close-Lost";
  const closeResult = isCloseStage
    ? currentStage === "Close-Won"
      ? "Won"
      : "Lost"
    : null;

  const stages = ["Lead", "In Contact", "Quotation Sent", "Close"];
  const normalizedStage = isCloseStage ? "Close" : currentStage;
  const currentIndex = stages.indexOf(normalizedStage);



  return (
    <div className="stage-container">
      {stages.map((stage, index) => (
        <div className="stage-item" key={stage}>
          {/* เส้นเชื่อม */}
          {index > 0 && (
            <div
              className={`stage-line ${
                index <= currentIndex ? "line-completed" : ""
              }`}
            />
          )}

          {/* วงกลมสถานะ */}
          <div
            className={`stage-circle ${
              index < currentIndex
                ? "completed"
                : index === currentIndex
                ? isCloseStage && closeResult === "Lost"
                  ? "active-lost"
                  : "active"
                : ""
            }`}
          >
            {index < currentIndex ? "✓" : index + 1}
          </div>

          {/* Label */}
          <div
            className={`stage-label ${
              index === currentIndex
                ? isCloseStage && closeResult === "Lost"
                  ? "label-lost"
                  : "label-active"
                : ""
            }`}
          >
            {stage}
            {stage === "Close" && (
              <>
                {" "}
                (
                <span
                  className={`substatus ${
                    closeResult === "Won"
                      ? "active-won"
                      : closeResult === "Lost"
                      ? "active-lost"
                      : ""
                  }`}
                >
                  {closeResult || "Won/Lost"}
                </span>
                )
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StageFlow;
